export const TABLE_UPDATE = "SUPPLIERS/TABLE_UPDATE";
export const FETCH_SUCCESS = "SUPPLIERS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "SUPPLIERS/DESTROY_FAILED",
    DESTROY_REQUEST: "SUPPLIERS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "SUPPLIERS/DESTROY_SUCCESS",

    FETCH_FAILED: "SUPPLIERS/FETCH_FAILED",
    FETCH_REQUEST: "SUPPLIERS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "SUPPLIERS/GET_FAILED",
    GET_REQUEST: "SUPPLIERS/GET_REQUEST",
    GET_SUCCESS: "SUPPLIERS/GET_SUCCESS",

    PATCH_FAILED: "SUPPLIERS/PATCH_FAILED",
    PATCH_REQUEST: "SUPPLIERS/PATCH_REQUEST",
    PATCH_SUCCESS: "SUPPLIERS/PATCH_SUCCESS",
    
    STORE_FAILED: "SUPPLIERS/STORE_FAILED",
    STORE_REQUEST: "SUPPLIERS/STORE_REQUEST",
    STORE_SUCCESS: "SUPPLIERS/STORE_SUCCESS",

    UPDATE_FAILED: "SUPPLIERS/UPDATE_FAILED",
    UPDATE_REQUEST: "SUPPLIERS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "SUPPLIERS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
